<template>
  <div class="col-sm-12 routa-light contact">
    <h1 class="title blue">{{ $t('contact.title') }}</h1>
    <b-form @submit.prevent="onSubmit">
        <b-form-group
                id="input-group-name"
        >
          <b-form-input
                  id="input-name"
                  type="text"
                  v-model="name"
                  required
                  :placeholder="$t('contact.name')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
                id="input-group-emai"
        >
          <b-form-input
                  id="input-3"
                  type="email"
                  v-model="email"
                  required
                  :placeholder="$t('contact.email')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
                id="input-group-phone"
        >
          <b-form-input
                  id="input-phone"
                  v-model="phone"
                  type="text"
                  required
                  :placeholder="$t('contact.phone')"
          ></b-form-input>
        </b-form-group>
        <b-form-group
                id="input-group-phone"
        >
          <b-form-textarea
                  id="textarea"
                  v-model="message"
                  :placeholder="$t('contact.message')"
                  rows="5"
                  max-rows="8"
          ></b-form-textarea>
        </b-form-group>
      <div class="col-sm-12 text-right">
        <b-button type="submit" class="carousel-btn" variant="primary">{{ $t('common.send')}}</b-button>
      </div>
    </b-form>
      <b-alert v-model="showSuccess" variant="success" dismissible>{{ $t('err.success')}}</b-alert>
      <b-alert v-model="showError" variant="danger" dismissible>{{ $t('err.send')}}</b-alert>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data: function () {
    return {
      showSuccess: false,
      showError: false,
      message: '',
      email: '',
      name: '',
      phone: ''
    }
  },
  methods: {
    onSubmit: function () {
        this.showSuccess = false
        this.showError = false
        let url = 'https://ficonicsolutions.com/mail/contact_me.php'
        let item = {name: this.name, phone: this.phone, email: this.email, message: this.message}
        this.axios.post(url, item, {
            headers: {Authorization: 'none'}
        })
        .then(response => {
            if (response.status === 200) {
                this.showSuccess = true
                this.name = ''
                this.phone = ''
                this.email = ''
                this.message = ''
            } else {
                this.showError = true
            }
        })
        .catch(e => {
            this.showError = true
        })
    }
  }
}
</script>

